import {
  Button,
  Card,
  Col,
  DatePicker,
  Form,
  Input,
  notification,
  Row,
} from "antd";
import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { API } from "../../config/api";
import { GET, POST, PUT } from "../../utils/apicalls";
import moment from "moment";

function UpdateMonthlyPlanner() {
  const [isLoading, setIsLoading] = useState(false);
  const [MonthlyPlannerData, setMonthlyPlannerData] = useState<any>({});
  const { id } = useParams();
  const [form] = Form.useForm();
  const navigate = useNavigate();
  useEffect(() => {
    getMonthlyPlannerData();
  }, []);

  const getMonthlyPlannerData = async () => {
    try {
      const api = `${API.GET_ONE_MONTHLY_PLANNER}${id}`;
      const response: any = await GET(api, {});
      setMonthlyPlannerData(response?.data || {});
      form.setFieldsValue({
        ...response?.data,
        date: response?.data?.date ? moment(response?.data.date) : null, // Convert date string to moment object
      });
    } catch (error) {
      console.error("Error fetching client data:", error);
    }
  };

  const submitHandler = async (values: any) => {
    try {


      let obj = {
        clientId: MonthlyPlannerData.clientId,
        date: values.date,
        contentIdea: values.contentIdea,
        channel: values.channel,
        contentType: values.contentType,
      };

      setIsLoading(true);
      const api = API.UPDATED_MONTHLY_PLANNER + id;
      const postRequest: any = await PUT(api, obj);

      if (postRequest) {
        notification.success({ message: "Planner updated successfully!" });
        form.resetFields();
      } else {
        notification.error({ message: "Something went wrong" });
      }
      navigate(-1);
    } catch (error) {
      console.error("Error while updating the planner:", error);
      notification.error({
        message: "Something went wrong! Please try again later",
      });
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div>
      <Card>
        <Form form={form} onFinish={submitHandler} layout="vertical">
          <Row gutter={16}>
            <Col sm={6}>
              <Form.Item
                name="contentIdea"
                label="Content Idea"
                rules={[{ required: true, message: "Enter content idea" }]}
              >
                <Input placeholder="Content Idea" />
              </Form.Item>
            </Col>

            <Col sm={6}>
              <Form.Item
                name="channel"
                label="Channel"
                rules={[{ required: true, message: "Enter channel" }]}
              >
                <Input placeholder="Channel" />
              </Form.Item>
            </Col>

            <Col sm={6}>
              <Form.Item
                name="contentType"
                label="Content Type"
                rules={[{ required: true, message: "Enter content type" }]}
              >
                <Input placeholder="Content Type" />
              </Form.Item>
            </Col>

            <Col sm={6}>
              <Form.Item
                name="date"
                label="Date"
                rules={[{ required: true, message: "Select date" }]}
              >
                <DatePicker format="YYYY-MM-DD" />
              </Form.Item>
            </Col>
          </Row>

          <Row>
            <Col span={24}>
              <Form.Item>
                <Button
                  type="primary"
                  htmlType="submit"
                  loading={isLoading}
                  block
                >
                  Update Planner
                </Button>
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </Card>
    </div>
  );
}

export default UpdateMonthlyPlanner;
